import { render, staticRenderFns } from "./DaftarProgramPemilikSistem.vue?vue&type=template&id=549645c4&"
import script from "./DaftarProgramPemilikSistem.vue?vue&type=script&lang=js&"
export * from "./DaftarProgramPemilikSistem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports